import React from 'react';
import PropTypes from 'prop-types';

import './AdditionalFacilitiesBanner.scss';

export default function AdditionalFacilitiesBanner({ location }) {
	return (
		<div className="additional-facilities-banner">
			Additional facilities near {location.city}, {location.state}
		</div>
	);
}

AdditionalFacilitiesBanner.propTypes = {
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired
	}).isRequired
};
